import React from "react";

import { BrowserRouter, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Footer from "./components/Footer";
import Header from "./components/Header";

import LandingPage from "./screens/LandingPage";
import Donations from "./screens/Donations";

import Step1 from "./screens/Step1";
import Step2 from "./screens/Step2";
import Step3 from "./screens/Step3";
// import Step4 from "./screens/Step4";

import "./styles.scss";

function App() {
    return (
        <BrowserRouter>
            <ToastContainer />
            <Header />
            <Switch>
                <Route path="/step1" component={Step1} />
                <Route path="/step2" component={Step2} />
                <Route path="/step3" component={Step3} />
                <Route path="/donations" component={Donations} />
                {/* <Route path="/step4" component={Step4} /> */}
                <Route path="/" component={LandingPage} />
            </Switch>
            <Footer />
        </BrowserRouter>
    );
}

export default App;
